/* Hauchklar – echte Bewertungen aus Judge.me in eigenem Design (Aufbau wie NOURI/Loox).
   Quelle: Judge.me Widget-API mit dem OEFFENTLICHEN Token (nur Lesen):
     GET https://judge.me/api/v1/widgets/product_review?api_token=…&shop_domain=…&handle=…&per_page=…&page=…
   Antwort: { widget: "<div class='jdgm-rev-widg' data-average-rating=… data-number-of-reviews=…> … .jdgm-rev … </div>" }
   Regeln: keine eigenen/erfundenen Inhalte. Solange 0 Bewertungen (oder kein Token) bleibt jeder Bereich unsichtbar.
   Konfiguration: window.HK_BEW = { token, shop, handle }   (im Theme aus den Theme-Einstellungen gesetzt)
   Vorschau des Layouts ohne Inhalte: ?bew_demo=1 (graue Platzhalter-Balken, keine Namen, keine Texte). */
(function () {
  'use strict';
  var CFG = window.HK_BEW || {};
  var DEMO = /[?&]bew_demo=1/.test(location.search) || CFG.demo === true;
  var boxes = [].slice.call(document.querySelectorAll('[data-hk-bew]'));
  if (!boxes.length) return;

  function esc(s) { return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; }); }
  var STERN = '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M12 2.5l2.9 6.1 6.6.8-4.9 4.6 1.3 6.6L12 17.3l-5.9 3.3 1.3-6.6L2.5 9.4l6.6-.8z"/></svg>';
  function sterne(n, cls) {
    var h = '<span class="' + (cls || 'hkb-sterne') + '" aria-label="' + (Math.round(n * 10) / 10).toString().replace('.', ',') + ' von 5 Sternen">';
    for (var i = 1; i <= 5; i++) h += '<i class="' + (n >= i - 0.25 ? 'voll' : n >= i - 0.75 ? 'halb' : 'leer') + '">' + STERN + '</i>';
    return h + '</span>';
  }
  function zahl(n, d) { return Number(n).toFixed(d).replace('.', ','); }
  function datum(s) { var d = new Date(s); return isNaN(d) ? '' : d.toLocaleDateString('de-DE', { day: 'numeric', month: 'long', year: 'numeric' }); }

  /* ---------- Judge.me lesen ---------- */
  function lesen(html) {
    var doc = new DOMParser().parseFromString('<div>' + html + '</div>', 'text/html');
    var w = doc.querySelector('.jdgm-rev-widg') || doc.body;
    var schnitt = parseFloat(w.getAttribute('data-average-rating')) || 0;
    var anzahl = parseInt(w.getAttribute('data-number-of-reviews'), 10) || 0;
    var verteilung = {};
    [].forEach.call(doc.querySelectorAll('.jdgm-histogram__row[data-rating]'), function (r) {
      verteilung[r.getAttribute('data-rating')] = { anzahl: parseInt(r.getAttribute('data-frequency'), 10) || 0, prozent: parseFloat(r.getAttribute('data-percentage')) || 0 };
    });
    var revs = [].map.call(doc.querySelectorAll('.jdgm-rev'), function (r) {
      var t = function (s) { var e = r.querySelector(s); return e ? e.textContent.trim() : ''; };
      var bilder = [].map.call(r.querySelectorAll('.jdgm-rev__pics img, .jdgm-rev__pic-img'), function (i) {
        return i.getAttribute('data-src') || i.getAttribute('src') || '';
      }).filter(Boolean);
      var ts = r.querySelector('.jdgm-rev__timestamp');
      return {
        id: r.getAttribute('data-review-id') || '',
        name: t('.jdgm-rev__author'),
        sterne: parseFloat((r.querySelector('.jdgm-rev__rating') || {}).getAttribute ? r.querySelector('.jdgm-rev__rating').getAttribute('data-score') : 0) || 0,
        titel: t('.jdgm-rev__title'),
        text: t('.jdgm-rev__body'),
        datum: ts ? (ts.getAttribute('data-content') || ts.textContent) : '',
        verifiziert: !!r.querySelector('.jdgm-rev__buyer-badge, [data-verified-buyer="true"]') || r.getAttribute('data-verified-buyer') === 'true',
        bilder: bilder
      };
    }).filter(function (r) { return r.text || r.titel || r.bilder.length; });
    if (!anzahl) anzahl = revs.length;
    if (!schnitt && revs.length) schnitt = revs.reduce(function (a, r) { return a + r.sterne; }, 0) / revs.length;
    return { schnitt: schnitt, anzahl: anzahl, verteilung: verteilung, revs: revs };
  }
  function holen(seite) {
    if (!CFG.token || !CFG.shop || !CFG.handle) return Promise.resolve(null);
    var u = 'https://judge.me/api/v1/widgets/product_review?api_token=' + encodeURIComponent(CFG.token) +
      '&shop_domain=' + encodeURIComponent(CFG.shop) + '&handle=' + encodeURIComponent(CFG.handle) +
      '&per_page=' + (CFG.per_page || 24) + '&page=' + (seite || 1);
    return fetch(u).then(function (r) { return r.ok ? r.json() : null; })
      .then(function (j) { return j && j.widget ? lesen(j.widget) : null; })
      .catch(function () { return null; });
  }

  /* ---------- Demo (nur Layout, keine Inhalte) ---------- */
  function demoDaten() {
    var revs = [];
    for (var i = 0; i < 16; i++) revs.push({ demo: true, sterne: 5, bilder: i < 8 ? ['demo'] : [], verifiziert: true });
    return { demo: true, schnitt: 0, anzahl: 0, verteilung: {}, revs: revs };
  }
  var BALKEN = function (w) { return '<span class="hkb-demo" style="width:' + w + '"></span>'; };

  /* ---------- Bausteine ---------- */
  function verteilungHtml(d) {
    var h = '';
    for (var s = 5; s >= 1; s--) {
      var v = d.verteilung[s] || { prozent: 0, anzahl: 0 };
      h += '<div class="hkb-vt-row"><span>' + s + ' Sterne</span><span class="hkb-vt-track"><span style="width:' + v.prozent + '%"></span></span><span>' + Math.round(v.prozent) + ' %</span></div>';
    }
    return h;
  }
  function verifiziert(r) { return r.verifiziert ? '<span class="hkb-verif"><svg viewBox="0 0 24 24"><path d="M12 1l2.6 2.2 3.4-.3.9 3.3 3 1.7-1.2 3.2 1.2 3.2-3 1.7-.9 3.3-3.4-.3L12 23l-2.6-2.2-3.4.3-.9-3.3-3-1.7L3.3 12 2.1 8.8l3-1.7.9-3.3 3.4.3z"/><path d="M8 12.5l2.6 2.5L16 9.5" fill="none" stroke="#fff" stroke-width="2"/></svg>Verifizierter Kauf</span>' : ''; }
  function fotoKarte(r) {
    if (r.demo) return '<article class="hkb-karte">' + (r.bilder.length ? '<div class="hkb-foto hkb-demo-foto"></div>' : '') +
      '<div class="hkb-karte-in">' + BALKEN('40%') + sterne(5) + BALKEN('100%') + BALKEN('85%') + BALKEN('60%') + '</div></article>';
    return '<article class="hkb-karte">' + (r.bilder[0] ? '<div class="hkb-foto"><img src="' + esc(r.bilder[0]) + '" alt="Foto von ' + esc(r.name) + '" loading="lazy"></div>' : '') +
      '<div class="hkb-karte-in"><div class="hkb-kopf"><b>' + esc(r.name) + '</b>' + verifiziert(r) + '</div>' + sterne(r.sterne) +
      (r.titel ? '<p class="hkb-titel">' + esc(r.titel) + '</p>' : '') + '<p class="hkb-text">' + esc(r.text) + '</p></div></article>';
  }
  function textKarte(r) {
    if (r.demo) return '<article class="hkb-zk"><div class="hkb-zk-top">' + sterne(5) + '</div>' + BALKEN('80%') + BALKEN('100%') + BALKEN('92%') + BALKEN('70%') + '<div class="hkb-zk-fuss">' + BALKEN('35%') + '</div></article>';
    return '<article class="hkb-zk"><div class="hkb-zk-top">' + sterne(r.sterne) + verifiziert(r) + '</div>' +
      (r.titel ? '<h4>„' + esc(r.titel) + '“</h4>' : '') + '<p>' + esc(r.text) + '</p>' +
      '<div class="hkb-zk-fuss"><b>' + esc(r.name) + '</b><span>' + esc(datum(r.datum)) + '</span></div></article>';
  }
  function listenZeile(r) {
    if (r.demo) return '<div class="hkb-li">' + sterne(5) + BALKEN('30%') + BALKEN('100%') + BALKEN('75%') + '</div>';
    return '<div class="hkb-li"><div class="hkb-li-kopf">' + sterne(r.sterne) + '<b>' + esc(r.name) + '</b>' + verifiziert(r) + '<span class="hkb-li-datum">' + esc(datum(r.datum)) + '</span></div>' +
      (r.titel ? '<p class="hkb-titel">' + esc(r.titel) + '</p>' : '') + '<p class="hkb-text">' + esc(r.text) + '</p>' +
      (r.bilder.length ? '<div class="hkb-li-bilder">' + r.bilder.map(function (b) { return '<img src="' + esc(b) + '" alt="" loading="lazy">'; }).join('') + '</div>' : '') + '</div>';
  }

  /* ---------- Produktseite: Summary oben, Foto-Raster, Karten, Liste ---------- */
  function pdp(box, d, nachladen) {
    var foto = d.revs.filter(function (r) { return r.bilder.length; });
    var ohne = d.revs.filter(function (r) { return !r.bilder.length; });
    var karten = ohne.slice(0, 6), liste = ohne.slice(6);
    var kopf = '<div class="hkb-summary"><div class="hkb-sum-links">' + sterne(d.demo ? 5 : d.schnitt, 'hkb-sterne hkb-gross') +
      '<button type="button" class="hkb-anzahl" aria-expanded="false">' + (d.demo ? BALKEN('110px') : zahl(d.schnitt, 1) + ' · ' + d.anzahl + ' Bewertungen') +
      ' <svg viewBox="0 0 24 24" width="16" height="16"><path d="M6 9l6 6 6-6" fill="none" stroke="currentColor" stroke-width="2"/></svg></button>' +
      '<div class="hkb-verteilung" hidden>' + verteilungHtml(d) + '</div></div></div>';
    var h = kopf;
    if (foto.length) h += '<div class="hkb-raster">' + foto.map(fotoKarte).join('') + '</div>';
    if (karten.length) h += '<div class="hkb-karten-wrap"><div class="hkb-karten">' + karten.map(textKarte).join('') + '</div>' +
      (karten.length > 1 ? '<div class="hkb-nav"><button type="button" data-r="-1" aria-label="Zurück">←</button><button type="button" data-r="1" aria-label="Weiter">→</button></div>' : '') + '</div>';
    h += '<div class="hkb-liste">' + liste.map(listenZeile).join('') + '</div>';
    if (!d.demo && d.anzahl > d.revs.length) h += '<div class="hkb-mehr-wrap"><button type="button" class="hkb-mehr">Mehr Bewertungen zeigen</button></div>';
    box.querySelector('[data-hk-bew-inhalt]').innerHTML = h;
    var knopf = box.querySelector('.hkb-anzahl'), vt = box.querySelector('.hkb-verteilung');
    knopf.addEventListener('click', function () { var auf = vt.hidden; vt.hidden = !auf; knopf.setAttribute('aria-expanded', String(auf)); });
    [].forEach.call(box.querySelectorAll('.hkb-nav button'), function (b) {
      b.addEventListener('click', function () { var k = box.querySelector('.hkb-karten'); k.scrollBy({ left: Number(b.getAttribute('data-r')) * (k.clientWidth * 0.9), behavior: 'smooth' }); });
    });
    var mehr = box.querySelector('.hkb-mehr'), seite = 1;
    if (mehr) mehr.addEventListener('click', function () {
      mehr.disabled = true; seite++;
      nachladen(seite).then(function (n) {
        if (!n || !n.revs.length) { mehr.parentNode.remove(); return; }
        box.querySelector('.hkb-liste').insertAdjacentHTML('beforeend', n.revs.map(listenZeile).join(''));
        mehr.disabled = false;
        if (box.querySelectorAll('.hkb-li,.hkb-karte,.hkb-zk').length >= d.anzahl) mehr.parentNode.remove();
      });
    });
  }

  /* ---------- Advertorial (Sullivan-Bausteine) ---------- */
  function seitenleiste(box, d) {
    box.querySelector('[data-hk-bew-inhalt]').innerHTML =
      '<div class="sidebar-cs-text">Kundenbewertungen</div><div class="sidebar-overall-rating">' + sterne(d.demo ? 5 : d.schnitt, 'sidebar-stars') +
      '<span class="sidebar-rating-num">' + (d.demo ? '' : zahl(d.schnitt, 1) + ' von 5') + '</span></div>' +
      '<div class="sidebar-rating-count">' + (d.demo ? BALKEN('60%') : d.anzahl + ' Kundenbewertungen') + '</div>' +
      [5, 4, 3, 2, 1].map(function (s) { var v = d.verteilung[s] || { prozent: 0 }; return '<div class="star-bar-row"><div class="star-bar-label">' + s + ' Sterne</div><div class="star-bar-track"><div class="star-bar-fill" style="width:' + v.prozent + '%"></div></div><div class="star-bar-pct">' + Math.round(v.prozent) + ' %</div></div>'; }).join('');
  }
  function kommentare(box, d) {
    var r4 = d.revs.filter(function (r) { return r.demo || r.text; }).slice(0, 4);
    box.querySelector('[data-hk-bew-inhalt]').innerHTML = '<div class="fb-sort-bar">Neueste <span class="fb-sort-caret">▾</span></div>' + r4.map(function (r) {
      var init = r.demo ? '' : esc((r.name || '?').charAt(0));
      return '<div class="fb-comment"><div class="fb-avatar" style="background:#0D7C66">' + init + '</div><div class="fb-comment-body"><div class="fb-bubble">' +
        (r.demo ? BALKEN('30%') + BALKEN('100%') + BALKEN('80%') : '<span class="fb-comment-name">' + esc(r.name) + '</span><span class="fb-comment-text">' + esc(r.text) + '</span>') +
        '</div><div class="fb-comment-meta"><span class="fb-timestamp">' + (r.demo ? '' : esc(datum(r.datum))) + '</span></div></div></div>';
    }).join('');
  }
  function kunden(box, d) {
    var r3 = d.revs.filter(function (r) { return r.demo || r.text; }).slice(4, 7);
    if (!r3.length) r3 = d.revs.slice(0, 3);
    box.querySelector('[data-hk-bew-inhalt]').innerHTML = r3.map(function (r) {
      return '<div class="review-wrap"><div class="review-wrap-inner"><div class="review-avatar-letter" style="background:#0D7C66">' + (r.demo ? '' : esc((r.name || '?').charAt(0))) + '</div><div class="review-content">' +
        (r.demo ? BALKEN('30%') + sterne(5, 'review-stars') + BALKEN('100%') + BALKEN('70%') :
          '<div class="review-username">' + esc(r.name) + (r.verifiziert ? ' <span class="verified">– Verifizierter Kauf</span>' : '') + '</div>' + sterne(r.sterne, 'review-stars') + '<div class="review-text">' + esc(r.text) + '</div>') +
        '</div></div></div>';
    }).join('');
  }

  var RENDER = { pdp: pdp, 'adv-seitenleiste': seitenleiste, 'adv-kommentare': kommentare, 'adv-kunden': kunden };
  (DEMO ? Promise.resolve(demoDaten()) : holen(1)).then(function (d) {
    if (!d || (!d.demo && (!d.anzahl || !d.revs.length))) return; /* 0 Bewertungen -> alles bleibt unsichtbar */
    boxes.forEach(function (box) {
      var f = RENDER[box.getAttribute('data-hk-bew')];
      if (!f) return;
      f(box, d, holen);
      box.hidden = false; box.classList.add('hkb-an');
    });
  });
})();
